import { useTrans } from "src/utils/useTrans";
import { CartStoreUtils } from "@/store/cart-store/cart-store-utils";
import { Button } from "@/v2-components/ui/button";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/v2-components/ui/dialog";

type BulkOrderDialogProps = {
  open: boolean;
  onOpenChange: () => void;
  onContactClick: () => void;
};

export default function BulkOrderDialog({
  open,
  onOpenChange,
  onContactClick,
}: BulkOrderDialogProps) {
  const { t } = useTrans(["gnb"]);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="flex min-h-[200px] max-w-[400px] flex-col p-8">
        <DialogHeader>
          <DialogTitle>{t("Purchase Limit")}</DialogTitle>
          <DialogClose />
        </DialogHeader>
        <DialogDescription className="flex-1">
          {/* ⚠️ 수량은 `CartStoreUtils.MAX_QUANTITY` 가 소유한다. 문구에 숫자를 박으면
              제한을 바꿀 때 7개 로케일 파일을 같이 고쳐야 하고, 하나만 놓쳐도 화면은
              "최대 4개" 라고 말하는데 5개가 담긴다 — 구매 수량 **고지**라 그냥 오타가 아니다. */}
          {t(
            "You can buy up to {{max}} items. For larger orders, please contact customer support.",
            { max: CartStoreUtils.MAX_QUANTITY },
          )}
        </DialogDescription>
        <DialogFooter className="w-full items-center justify-end gap-2">
          <Button
            variant={"blue-fill"}
            shape={"pill"}
            size={"sm"}
            className="!px-6"
            onClick={() => {
              onOpenChange();
              onContactClick();
            }}
          >
            {/* ⚠️ 이 버튼은 대량주문 문의 폼을 연다. 종전 `Contact` 는 동작이 모호해
                `Request Order` 로 교체했다(#5281). `Contact` 키 자체는 다른 화면
                (`where-to-try`·`support` 네임스페이스)에서 계속 쓴다 — 값을 바꾸지 말 것. */}
            {t("Request Order")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
